import { ThemeOptions, createTheme as createMuiTheme } from '@mui/material';
import { createPalette } from './create-palette';
import { createComponents } from './create-components';
import { createShadows } from './create-shadows';
import { createTypography } from './create-typography';
import { Themes } from './themeTypes';

export function createTheme(theme : Themes) {
  const palette = createPalette(theme);
  const components = createComponents(palette);
  const shadows = createShadows();
  const typography = createTypography();

  const options: ThemeOptions = {
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1440,
      },
    },
    components,
    palette,
    shadows,
    shape: {
      borderRadius: 8,
    },
    typography,
  };

  return createMuiTheme(options);
}
